import { select, selectAll } from '@neptune/cx/utils';


export class CheckboxTree {
    rootEl: HTMLUListElement;
    children: CheckboxTreeNode[] = [];

    constructor(topLevelList: HTMLUListElement) {
        this.rootEl = topLevelList;
        const listItems = selectAll<HTMLLIElement>(topLevelList, '& > .ay-category-tree-facet__item');
        for (const listItem of listItems) {
            this.children.push(new CheckboxTreeNode(listItem, null));
        }
    }
}

export class CheckboxTreeNode implements Disposable {
    static CheckboxInstanceMap = new Map<HTMLInputElement, CheckboxTreeNode>();

    static getInstance(checkboxEl: HTMLInputElement): CheckboxTreeNode | null {
        return CheckboxTreeNode.CheckboxInstanceMap.get(checkboxEl) ?? null;
    }

    parent: CheckboxTreeNode | null = null;
    children: CheckboxTreeNode[] = [];
    checkboxEl: HTMLInputElement;
    itemEl: HTMLLIElement | null = null;

    constructor(listItemEl: HTMLLIElement, parent: CheckboxTreeNode | null = null) {
        this.itemEl = listItemEl;
        this.checkboxEl = select<HTMLInputElement>(listItemEl, '& > label input[type="checkbox"]');
        this.parent = parent;

        const sublistEl = this.itemEl.querySelector<HTMLUListElement>('& > .ay-category-tree-facet__list');

        if (sublistEl) {
            const childListItems = selectAll<HTMLLIElement>(sublistEl, '& > li.ay-category-tree-facet__item');
            for (const childItem of childListItems) {
                const childNode = new CheckboxTreeNode(childItem, this);
                this.children.push(childNode);
            }
        }

        CheckboxTreeNode.CheckboxInstanceMap.set(this.checkboxEl, this);
    }

    get value(): string {
        return this.checkboxEl.value;
    }

    get valuesFlat(): string[] {
        return this.childrenFlat.map(child => child.value);
    }

    get indeterminate(): boolean {
        return this.checkboxEl.indeterminate;
    }

    get childrenFlat(): CheckboxTreeNode[] {
        return this.children.reduce((acc, child) => [
            ...acc, child, ...child.childrenFlat
        ], [this] as CheckboxTreeNode[]);
    }

    [Symbol.dispose](): void {
        CheckboxTreeNode.CheckboxInstanceMap.delete(this.checkboxEl);
    }
}